import { render, staticRenderFns } from "./MicrofilmComponent.vue?vue&type=template&id=b315ceba&scoped=true"
import script from "./MicrofilmComponent.vue?vue&type=script&lang=js"
export * from "./MicrofilmComponent.vue?vue&type=script&lang=js"
import style0 from "./MicrofilmComponent.vue?vue&type=style&index=0&id=b315ceba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b315ceba",
  null
  
)

export default component.exports